<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import ModalContainer from '../$components/modal.container.svelte'

    import ShipmentModal from './modal.shipment.svelte'
    import ShipmentsComponent from './component.shipments.svelte'
    import ShipmentsReportComponent from './component.shipments.report.svelte'

    if(!isPermission($adminStore, 'ShipmentsView'))
        replace('/404')

</script>

<View>
    <PageHeader title="Envíos" subtitle="Gestiona y rastrea todos los envíos" />
    <ShipmentsComponent />
</View>

<ShipmentModal />

<ModalContainer id="shipments_report_modal" >
    <ShipmentsReportComponent all={true} />
</ModalContainer>